import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=7552a97b&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=7552a97b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7552a97b",
  null
  
)

export default component.exports